import { useQuery } from "@tanstack/react-query";
import client from "shared/utils/axios-config";
import { Business, BusinessDto, DashboardAnalytics, SearchParams } from "shared/types";
import { CalendarSchedule } from "components/WeeklyCalendar/components/types";
import { now } from "shared/utils/dayjs";
import { searchSchedulesV2 } from "../api/schedule-v2";

/* eslint-disable react-hooks/rules-of-hooks */

const getDashboardAnalytics = () => {
  return useQuery({
    queryKey: ["business", "dashboard"],
    queryFn: async (): Promise<DashboardAnalytics | undefined> => {
      const res = await client.get("/v1/business/dashboard");
      if (res.status === 200 && !res.data?.error) {
        return res.data.data;
      }
    },
  });
};

const getAllBusiness = (searchParams: SearchParams, options = {}) => {
  return useQuery({
    queryKey: ["business", searchParams],
    queryFn: async (): Promise<Business[] | undefined> => {
      const res = await client.get("/v1/business", { params: searchParams });
      if (res.status === 200 && !res.data?.error) {
        return res.data.data;
      }
    },
  });
};

const getBusinessById = (business_id?: string) => {
  return useQuery({
    queryKey: ["business", business_id],
    queryFn: async (): Promise<BusinessDto | undefined> => {
      const res = await client.get(`/v1/business/${business_id}`);
      if (res.status === 200 && !res.data?.error) {
        return res.data.data;
      }
    },
    enabled: !!business_id,
  });
};

// Today's schedules for the dashboard widget. Pulls every occurrence on the
// current day from the v2 search endpoint; the page filters to upcoming/
// in-progress and trims to the first 5.
const getDashboardSchedules = () => {
  return useQuery({
    queryKey: ["business", "dashboard", "schedules", "v2"],
    queryFn: async (): Promise<CalendarSchedule[]> => {
      const today = now();
      return searchSchedulesV2({
        start_date: today.startOf("day").toISOString(),
        end_date: today.endOf("day").toISOString(),
        include_cancelled: false,
      });
    },
  });
};

export { getAllBusiness, getBusinessById, getDashboardAnalytics, getDashboardSchedules };
